import * as PIXI from "pixi.js";
import { DeviceUtil } from "../../util/device/DeviceUtil";
import { EventHandler } from "../../util/event/EventHandler";
import { GraphicsUtil } from "../../util/view/GraphicsUtil";
import { MouseUtil } from "../../util/view/MouseUtil";
import { AbstractControl } from "./AbstractControl";
/**
 * Swipe.ts
 */
export class Swipe extends AbstractControl {
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
    }
    create() {
        super.create();
        this.isTouch = DeviceUtil.isTouch();
        this.createRectangle();
        this.addMouseListeners();
    }
    createRectangle() {
        this.rectangle = GraphicsUtil.createRectangle(this.uiProperties.size);
        this.addChild(this.rectangle);
    }
    addMouseListeners() {
        MouseUtil.setInteractive(this, true);
        MouseUtil.addMouseDown(this, this.handleMouseDown, this);
        MouseUtil.addMouseUp(this, this.handleMouseUp, this);
    }
    setEnabled(value) {
        MouseUtil.setInteractive(this, value);
    }
    handleMouseDown(event) {
        this.downPosition = event.getLocalPosition(this);
    }
    handleMouseUp(event) {
        this.upPosition = event.getLocalPosition(this);
        this.globalUpPosition = event.global.clone();
        if (this.downPosition) {
            let xSwipe = this.upPosition.x - this.downPosition.x;
            let ySwipe = this.upPosition.y - this.downPosition.y;
            let xStrength = Math.abs(xSwipe);
            let yStrength = Math.abs(ySwipe);
            if (!this.isTouch || (xStrength > yStrength)) {
                this.handleHorizontal(xSwipe, xStrength);
            }
            else {
                this.handleVertical(ySwipe, yStrength);
            }
        }
    }
    handleHorizontal(xSwipe, xStrength) {
        let handler;
        if (this.isTouch) {
            if (xStrength > this.uiProperties.sensitivity) {
                handler = xSwipe < 0 ? this.swipeRightHandler : this.swipeLeftHandler;
            }
            else {
                if (this.hasSelectedItem()) {
                    handler = this.clickHandler;
                }
            }
        }
        else {
            if (this.hasSelectedItem()) {
                handler = this.clickHandler;
            }
            else {
                let centreX = Math.round(this.uiProperties.size.x / 2);
                handler = this.upPosition.x < centreX ? this.swipeLeftHandler : this.swipeRightHandler;
            }
        }
        this.callHandler(handler);
    }
    handleVertical(ySwipe, yStrength) {
        let handler;
        if (this.isTouch) {
            if (yStrength > this.uiProperties.sensitivity) {
                handler = ySwipe < 0 ? this.swipeDownHandler : this.swipeUpHandler;
            }
            else {
                if (this.hasSelectedItem()) {
                    handler = this.clickHandler;
                }
            }
        }
        else {
            if (this.hasSelectedItem()) {
                handler = this.clickHandler;
            }
            else {
                let centreY = Math.round(this.uiProperties.size.y / 2);
                handler = this.upPosition.x < centreY ? this.swipeUpHandler : this.swipeDownHandler;
            }
        }
        if (handler) {
            handler.call();
        }
    }
    hasSelectedItem() {
        this.selectedItem = null;
        if (this.selectableItems) {
            for (let i = this.selectableItems.length - 1; i >= 0; i--) {
                let nextItem = this.selectableItems[i];
                if (this.isInBounds(this.globalUpPosition, nextItem)) {
                    this.selectedItem = nextItem;
                    return true;
                }
            }
        }
        return false;
    }
    resize(transform) {
        this.removeChild(this.rectangle);
        let newSize = new PIXI.Point(this.uiProperties.size.x + transform.x, this.uiProperties.size.y + transform.y);
        this.rectangle = GraphicsUtil.createRectangle(newSize);
        this.addChild(this.rectangle);
        this.hitArea = new PIXI.Rectangle(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
    }
    isInBounds(mouse, item) {
        let rectangle = new PIXI.Rectangle(item.worldTransform.tx, item.worldTransform.ty, item.width, item.height);
        return rectangle.contains(mouse.x, mouse.y);
    }
    update(data) {
        this.selectableItems = data;
    }
    getMousePosition() {
        return this.upPosition;
    }
    getSelectedItem() {
        return this.selectedItem;
    }
    onClick(handler, scope) {
        this.clickHandler = new EventHandler(handler, scope);
    }
    onSwipeLeft(handler, scope) {
        this.swipeLeftHandler = new EventHandler(handler, scope);
    }
    onSwipeRight(handler, scope) {
        this.swipeRightHandler = new EventHandler(handler, scope);
    }
    onSwipeUp(handler, scope) {
        this.swipeUpHandler = new EventHandler(handler, scope);
    }
    onSwipeDown(handler, scope) {
        this.swipeDownHandler = new EventHandler(handler, scope);
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.resize(this.renderer.getSafeTransform());
    }
}
//# sourceMappingURL=Swipe.js.map